<template>
  <div class="particle-container">
    <div v-for="(particle, index) in particles" :key="index" class="particle" :style="particle.style"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      particles: [],
      screenWidth: 650,
      screenHeight: 450,
      particleCountRange: [50, 100],
      particleColor: "#ffffff", // 粒子颜色
      backgroundImage: require('@/assets/starry-night.jpg'), // 使用require引用资源
    };
  },
  methods: {
    generateParticle() {
      const particle = {
        x: Math.random() * this.screenWidth,
        y: -5, // 从顶部随机出现
        speed: Math.random() * 2 + 1,
        style: {
          left: 0,
          top: 0,
          background: this.particleColor,
        },
      };

      this.particles.push(particle);
    },
    updateParticles() {
      for (let i = this.particles.length - 1; i >= 0; i--) {
        const particle = this.particles[i];

        particle.y += particle.speed; // 从底部新增
        particle.style.left = `${particle.x}px`;
        particle.style.top = `${particle.y}px`;

        if (particle.y > this.screenHeight) {
          this.particles.splice(i, 1);
        }
      }
    },
    startParticleGeneration() {
      const particleInterval = 1000 / (this.particleCountRange[1] - this.particleCountRange[0] + 1);
      setInterval(() => {
        const particleCount = Math.floor(Math.random() * (this.particleCountRange[1] - this.particleCountRange[0] + 1)) + this.particleCountRange[0];
        for (let i = 0; i < particleCount; i++) {
          this.generateParticle();
        }
      }, particleInterval);
    },
  },
  mounted() {
    this.startParticleGeneration();
    setInterval(() => {
      this.updateParticles();
    }, 30);
  },
};
</script>

<style>
.particle-container {
  position: relative;
  width: 650px;
  height: 450px;
  overflow: hidden;
  z-index:1;
  background-image: url('~@/assets/starry-night.jpg'); /* 使用require引用的资源路径 */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0 0;
  opacity: 0.9;
}



.particle {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  z-index: 2;
}
</style>
